import type { CSSProperties, PropsWithChildren } from "react";
import { cn } from "tailwind-variants";

interface IGrid {
	className?: string;
	columns?: number;
	id?: string;
	style?: CSSProperties;
}

export function Grid({
	children,
	className,
	columns = 12,
	id,
	style,
}: PropsWithChildren<IGrid>) {
	const columnsMap: Record<number, string> = {
		1: "grid-cols-1",
		2: "grid-cols-2",
		3: "grid-cols-3",
		4: "grid-cols-4",
		5: "grid-cols-5",
		6: "grid-cols-6",
		7: "grid-cols-7",
		8: "grid-cols-8",
		9: "grid-cols-9",
		10: "grid-cols-10",
		11: "grid-cols-11",
		12: "grid-cols-12",
	};

	const mergedClasses = cn("grid", columnsMap[columns], className);
	return (
		<div id={id ?? ""} className={mergedClasses} style={style}>
			{children}
		</div>
	);
}

interface IGridItem {
	className?: string;
	columnSpan?: number;
}

export function GridColumn({
	children,
	className,
	columnSpan = 12,
}: PropsWithChildren<IGridItem>) {
	const spanMap: Record<number, string> = {
		1: "lg:col-span-1",
		2: "lg:col-span-2",
		3: "lg:col-span-3",
		4: "lg:col-span-4",
		5: "lg:col-span-5",
		6: "lg:col-span-6",
		7: "lg:col-span-7",
		8: "lg:col-span-8",
		9: "lg:col-span-9",
		10: "lg:col-span-10",
		11: "lg:col-span-11",
		12: "lg:col-span-12",
	};

	const lgSpan = spanMap[columnSpan] || "lg:col-span-12";

	return <div className={cn("col-span-12", lgSpan, className)}>{children}</div>;
}
